export default __webpack_public_path__ + "static/media/programmer.d3c9116b.jpg";